export default __webpack_public_path__ + "static/two-seven-f8ced7420a5edde8c6b81932c9ed8df8.png";